import React from "react";

export function SmallDivider(props: { style?: React.CSSProperties }) {
  return (
    <hr
      className="hr"
      style={{
        maxWidth: "75%",
        margin: "auto",
        marginTop: "1em",
        marginBottom: "1em",
        ...props.style,
      }}
    />
  );
}

export function FullDivider() {
  return <hr className="hr is-marginless" />;
}

export function VerticalDivider(props: { style?: React.CSSProperties }) {
  return (
    <div className="is-divider-vertical" style={props.style}>
      &nbsp;
    </div>
  );
}
